import { IBrand } from "@faire/web-api/indigofair/data/IBrand";
import { IUserTranslatedString } from "@faire/web-api/indigofair/data/IUserTranslatedString";

import { loadable } from "@faire/retailer/lib/loadable";
import { handleComponentLoadError } from "@faire/retailer/lib/loadChunkErrors";

export interface IStoryModalProps {
  brand: Pick<
    IBrand,
    | "token"
    | "based_in_city"
    | "based_in_state"
    | "based_in"
    | "name"
    | "description"
    | "creation_year"
    | "badges"
    | "video_url"
    | "profile_image"
    | "story_images"
    | "instagram_handle"
    | "made_in"
    | "tags"
  >;
  onClose: () => void;
  brandDescription?: IUserTranslatedString;
  aboutSubheader?: string | null;
}

export const LazyStoryModal = loadable(
  () =>
    import(/* webpackChunkName: "retailer-story-modal" */ "./StoryModal").catch(
      handleComponentLoadError
    ),
  { resolveComponent: (m) => m.StoryModal }
);
